import { ToggleButton, ToggleButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledChip = styled(ToggleButton)<ToggleButtonProps>(
  ({ theme: { spacing, palette, colors } }) => ({
    '&.MuiToggleButton-root': {
      backgroundColor: colors.chipsDefault,
      padding: spacing(0.65, 1.2),
      border: 'none',
      fontWeight: 400,
      textTransform: 'none',
      color: palette.common.black,
      minWidth: 0,

      '& .MuiSvgIcon-root': {
        marginRight: spacing(1.2),
      },

      '&.Mui-selected': {
        backgroundColor: palette.primary.main,
        padding: spacing(0.4, 1.2, 0.4, 0.4),
      },

      '&.Mui-disabled': {
        backgroundColor: palette.action.disabledBackground,
        color: palette.action.disabled,
        cursor: 'not-allowed',
      },
    },
  })
);
